module.exports = __webpack_public_path__ + "static/media/rotate-b2.4.36079464.svg";